// extracted by mini-css-extract-plugin
export default {"name":"UserSettingsComponent_name__YD5Ac","item":"UserSettingsComponent_item__ztnz0"};